module.exports = __webpack_public_path__ + "img/float-tab.fcce0911.svg";